// extracted by mini-css-extract-plugin
module.exports = {"popup":"components-Popup-Popup__popup--1zC-u","confirm-button":"components-Popup-Popup__confirm-button--3neSz","message":"components-Popup-Popup__message--3-RWA"};